import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { usePermission, useTranslation } from "../../../hooks";
import { useZusListStore } from "../../../zustand/store";
import BalanceTab from "./BalanceTab";
import RentRequestTab from "./RentRequestTab";
import { FeatureCode } from "@wallet-manager/node-types";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
const translatePrefix = "tronWalletResourceBalance";
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index} //hidden all if no index==value
      id={`simple-tabpanel-${index}`} //showing which tab
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && ( //if value match, then display the target tab-content
        <Box>{children}</Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TronWalletResourceBalance = () => {
  const [tabsIndex, setTabIndex] = React.useState(0); //the default index :which tab
  const { t } = useTranslation(translatePrefix);
  const { hasPermission } = usePermission();
  const clearZusList = useZusListStore((state) => state.clear);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
    clearZusList();
  };
  const tabs = [
    {
      name: "balance",
      path: FeatureCode.FeaturesWalletManagement.TronRentResourceBalance
        .TabBalance.prefix,
      index: 0,
      jsxNode: <BalanceTab />,
    },
    {
      name: "rent_request",
      path: FeatureCode.FeaturesWalletManagement.TronRentResourceBalance
        .TabRentRequest.prefix,
      index: 1,
      jsxNode: <RentRequestTab />,
    },
  ].filter((item) => hasPermission(item.path));

  return (
    <Box
      sx={{
        backgroundColor: "white",
        paddingTop: "2rem",
      }}
    >
      <Tabs
        sx={{ margin: "0 1.5rem", borderBottom: "solid #E1E4EA 1px" }}
        value={tabsIndex}
        onChange={handleChange}
      >
        {tabs.map((item, index) => {
          return (
            <Tab key={index} label={t(`${item.name}`)} {...a11yProps(index)} />
          );
        })}
      </Tabs>
      {/* Real Tab Content */}
      {tabs.map((item, index) => {
        return (
          <TabPanel key={index} value={tabsIndex} index={index}>
            {item.jsxNode}
          </TabPanel>
        );
      })}
    </Box>
  );
};

export default TronWalletResourceBalance;
